/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { EarnStackRoutes, FeatureModule } from '@/features/earn';
import { LinkingOptions } from '@react-navigation/native';
import { pick } from 'lodash';

import { RootStackParamList, RootStackRoutes } from '../types';

export function bulidLinkingConfig(apps: FeatureModule[]): LinkingOptions<any> {
  let appRoutes = {};
  apps
    .filter((a) => a.routes)
    .forEach((a) => {
      appRoutes = {
        ...appRoutes,
        ...a.routes
      };
    });

  return {
    enabled: true,
    prefixes: [],
    config: {
      initialRouteName: RootStackRoutes.Root,
      screens: {
        [RootStackRoutes.Root]: {
          path: '/'
        },
        ...appRoutes,
        NotFound: '*'
      }
    }
  };
}
